import React from 'react';
import { Box } from '@material-ui/core';
import ByQuestionModuleTypeChart from 'components/ReportsModule/components/KeyboardingReport/Classroom/charts/ByQuestionModuleTypeChart';
import { useTranslation } from 'react-i18next';
import { KeyClassroomEngagementReportResult } from 'types/schema-generated-types';
import { ReportEntityType } from 'components/ReportsModule/types';
import useReportQueryParams from 'components/ReportsModule/hooks/use-report-query-params';

type Props = {
  reportData?: KeyClassroomEngagementReportResult;
  selectedModule?: string;
};

const AllStudentChartClassBreakDown = ({ reportData, selectedModule }: Props) => {
  const { t } = useTranslation('Reports');
  const [, setQuery] = useReportQueryParams();
  const studentLabels = reportData?.students.map(
    s => `${s.student?.firstName} ${s.student?.lastName}`
  );
  const timeSpentData: any =
    reportData?.students.map(s => s.assessmentAccelerator?.averageSecondsSpent ?? 0) ?? [];

  const attemptCountData: any = reportData?.students.map(
    s => s.assessmentAccelerator?.averageAttemptCount ?? 0
  );
  const handleChartClick = (index: number) => {
    const studentId = reportData?.students[index]?.student?.id;
    setQuery({ entityType: ReportEntityType.STUDENT, entityId: studentId }, 'pushIn');
  };

  return (
    <>
      <Box marginBottom={4}>
        <ByQuestionModuleTypeChart
          title="By Student - Average Time Spent per Question"
          helpText={t('averageTimeToCompleteQuestionHelp', { ns: 'ReportsHelpCards' })}
          yAxisText={t('Avg. Time Spent per Question (seconds)')}
          labels={studentLabels!}
          series={[{ name: 'seconds', data: timeSpentData }]}
          colors={['#404261']}
          onClick={handleChartClick}
        />
      </Box>
      <Box>
        <ByQuestionModuleTypeChart
          title="By Student - Average Number of Tries per Question"
          helpText={t('averageNumberOfTriesQuestionHelp', { ns: 'ReportsHelpCards' })}
          yAxisText={'Avg. No. of Tries per Question'}
          labels={studentLabels!}
          series={[{ name: 'tries', data: attemptCountData }]}
          colors={['#7FAD6A']}
          onClick={handleChartClick}
        />
      </Box>

      {/* <DownloadListCard
        onClick={openConstructAResponse}
        title="View Question Results"
        Icon={GetAppIcon}
        data={downloadData as any}
        xs={12}
      /> */}
    </>
  );
};

export default AllStudentChartClassBreakDown;
